import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "パスワード再設定")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "card-title" }, "メールアドレス宛に再設定用URLを送付します。", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary col-4",
    type: "submit"
  }, "送信")
], -1)

import { ref, unref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useNicotto } from '@/plugins/nicotto'
  import { useMessenger } from '@/plugins/message'
  import { useValidateForm } from '@/components/ui/validator'
  import FormGroup from '@/components/ui/FormGroup.vue'
  import InputEmail from '@/components/ui/InputEmail.vue'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

  const email = ref('')
  const formRef = ref<HTMLFormElement|null>(null)
  const router = useRouter()
  const nicotto = useNicotto()
  const messenger = useMessenger()

  const forgotPassword = async() => {
    const form = unref(formRef) as unknown as HTMLFormElement
    if (useValidateForm(form).isValid()) {
      try {
        if (email.value) {
          await nicotto.auth.forgotPassword(email.value)
          router.push('/forgot/sendmail')
        }
      } catch (err) {
        if (err && typeof err == "object" && Object.keys(err).length != 0) {
          for (const [key, val] of Object.entries(err)) {
            if (key=="name") {
              switch (val) {
                case "LimitExceededException": //実行制限（リクエスト数/h）
                  messenger.set('forgot.retryLater')
                  break
                default: //存在しないアドレス等の場合は、セキュリティの観点から無条件でメール送信完了画面に遷移させる
                  router.push('/forgot/sendmail')
                  break
              }
              return false
            }
          }
        }
        router.push('/forgot/sendmail')
      }
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: _withModifiers(forgotPassword, ["prevent"]),
          ref_key: "formRef",
          ref: formRef,
          class: "formTable",
          novalidate: ""
        }, [
          _createVNode(FormGroup, {
            label: "メールアドレス",
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputEmail, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                label: "メールアドレス",
                autocomplete: "username",
                required: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_7
        ], 40, _hoisted_6)
      ])
    ])
  ]))
}
}

})